const moduleName = 'profile';

import { components, reducers } from 'linksoft';

import profile from './profile';
import reducer from './reducer';

components.add(moduleName, profile);

reducers.add(moduleName, reducer);

export default {
    name: moduleName,
    containers: [profile],
    reducer: reducer
};


// WEBPACK FOOTER //
// ./App/components/modules/profile/index.js